import { render, staticRenderFns } from "./arearSelect.vue?vue&type=template&id=63c221ee&scoped=true"
import script from "./arearSelect.vue?vue&type=script&lang=js"
export * from "./arearSelect.vue?vue&type=script&lang=js"
import style0 from "./arearSelect.vue?vue&type=style&index=0&id=63c221ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c221ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c221ee')) {
      api.createRecord('63c221ee', component.options)
    } else {
      api.reload('63c221ee', component.options)
    }
    module.hot.accept("./arearSelect.vue?vue&type=template&id=63c221ee&scoped=true", function () {
      api.rerender('63c221ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/myQualification/components/arearSelect.vue"
export default component.exports